module.exports = __webpack_public_path__ + "img/menu-black.c59ef144.svg";